<template>
  <!-- Modal -->
  <div class="modal-wrapper">
    <div class="modal-form">
      <div class="modal-header d-flex  justify-content-between">
        <h1>Add new Book</h1>
        <!-- <div
          type="button"
          class="btn btn-outline-secondary"
          @click="closeModal"
        >
          Cancel
        </div> -->
        <router-link class="btn btn-outline-secondary" to="/"
          >Cancel</router-link
        >
      </div>
      <div class="modal-content">
        <form>
          <div class="form-group">
            <label for="author">author</label>
            <input
              type="text"
              class="form-control"
              v-model="newBook.author"
              placeholder="Enter Book Author"
            />
            <label for="title">title</label>
            <input
              type="text"
              class="form-control"
              v-model="newBook.title"
              placeholder="Enter Book Title"
            />
            <label for="subtitle">subtitle</label>
            <input
              type="text"
              class="form-control"
              v-model="newBook.subtitle"
              placeholder="Enter Book Subtitle"
            />
            <label for="description">description</label>
            <input
              type="text"
              class="form-control"
              v-model="newBook.description"
              placeholder="Enter Book Description"
            />
            <label for="isbn">isbn</label>
            <input
              type="text"
              class="form-control"
              v-model="newBook.isbn"
              placeholder="Enter Book ISBN"
            />
            <label for="cover">cover</label>
            <input
              type="text"
              class="form-control"
              v-model="newBook.cover"
              placeholder="Enter Book COVER URL"
            />
            <label for="tags">tags</label>
            <input
              type="text"
              class="form-control"
              v-model="newBook.tags"
              placeholder="Enter Book Tags"
            />
            <label for="category">category</label>
            <input
              type="text"
              class="form-control"
              v-model="newBook.category"
              placeholder="Enter Book Category"
            />
            <label for="createdAt">createdAt</label>
            <input
              type="text"
              readonly
              class="form-control-plaintext"
              v-model="newBook.createdAt"
              placeholder="Enter Book created Date"
            />
            <label for="isBorrowed">isBorrowed</label>
            <input
              type="text"
              class="form-control"
              v-model="newBook.isBorrowed"
              placeholder="Enter Book Author"
            />
          </div>
        </form>
      </div>
      <div class="modal-footer  d-block">
        <div class="form-group d-flex justify-content-between">
          <div type="button" class="btn btn-success" @click="addBookToDB()">
            Submit
          </div>
          <div
            type="button"
            class="btn btn-success"
            @click="addSampleBookToDB()"
          >
            Add Sample
          </div>
        </div>
        <pre>{{ newBook }}</pre>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import firebase from 'firebase';

export default {
  name: 'Home',
  data() {
    return {
      user: null,
      showAddBookForm: false,
      newBook: {
        author: null,
        title: null,
        description: null,
        isbn: null,
        cover: null,
        tags: null,
        category: null,
        createdAt: new Date(),
        isBorrowed: null,
      },
    };
  },
  props: {
    status: Boolean,
  },
  created() {
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        this.user = user;
      } else {
        this.user = null;
      }
    });
  },
  methods: {
    closeModal() {},
    addBookToDB() {
      var vm = this;
      if (firebase.auth().currentUser) {
        firebase
          .firestore()
          .collection('books')
          .add({
            owner: firebase.auth().currentUser.uid,
            author: this.newBook.author,
            title: this.newBook.title,
            subtitle: this.newBook.subtitle,
            description: this.newBook.description,
            isbn: this.newBook.isbn,
            cover: this.newBook.cover,
            category: this.newBook.category,
            createdAt: new Date(),
            isBorrowed: false,
          })
          .then(function() {
            // console.log('Book successfully written!');
            vm.$router.push('/');
          });
      }
    },
    addSampleBookToDB() {
      var vm = this;

      if (firebase.auth().currentUser) {
        firebase
          .firestore()
          .collection('books')
          .add({
            owner: firebase.auth().currentUser.uid,
            author: 'author',
            title: 'title',
            description: 'description',
            isbn: 'isbn',
            cover: 'cover',
            category: 'category',
            createdAt: new Date(),
            isBorrowed: false,
          })
          .then(function() {
            // console.log('Book successfully written!');
            vm.$router.push('/');
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
